module.exports = __webpack_public_path__ + "img/electronic_no_zone_selected.22946a5e.svg";